<div class="container-passport">
  <div>
    <img src="../../../assets/images/header.png" style="height: 32px" />
    <span>{{ 'app.passport.company' | i18n }}</span>
  </div>
  <div>
    <div>
      <div>
        {{ 'app.passport.name' | i18n }}
        <header-i18n showLangText="false" class="langs" />
      </div>
      <router-outlet />
    </div>
  </div>
</div>
<div class="foot">
  <div class="copyright">
    Copyright © 2021-2024 Phoenix Contact All Rights Reserved.
    <br />
    <a href="https://beian.miit.gov.cn/#/Integrated/index">备案号：苏ICP备19022095号-1</a>
  </div>
</div>
